import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "prop-container"
};
const _hoisted_2 = {
  class: "props-name"
};
const _hoisted_3 = {
  class: "props-type"
};
const _hoisted_4 = {
  class: "props-price"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  class: "item-content"
};
const _hoisted_7 = {
  class: "item-content"
};
const _hoisted_8 = {
  class: "item-content"
};
const _hoisted_9 = {
  class: "item-content"
};
const _hoisted_10 = {
  class: "item-desc"
};
const _hoisted_11 = {
  class: "item-name"
};
const _hoisted_12 = {
  key: 1
};
const _hoisted_13 = {
  class: "transaction-title"
};
const _hoisted_14 = {
  class: "transaction-content"
};
const _hoisted_15 = {
  class: "transaction-content"
};
const _hoisted_16 = {
  class: "transaction-title"
};
const _hoisted_17 = {
  class: "transaction-desc"
};
const _hoisted_18 = {
  class: "transaction-content"
};
const _hoisted_19 = {
  key: 2
};
const _hoisted_20 = {
  class: "admin-transaction-container"
};
import { ref, computed, onMounted } from 'vue';
import { ElInputNumber, ElMessage } from 'element-plus';
import { calculateMD5, compressImage, inApostleType, isAdminType, isUserType, isValid, parseToCostDesc, propsDefaultImage } from '@/tools/utils';
import { request } from '@/manager/net_manager';
import store from '@/store';
import 'element-plus/es/components/input-number/style/css';
import RoleFinder from "@/components/Role/RoleFinder.vue";
export default {
  __name: 'MarketPropsCard',
  props: {
    propId: {
      type: String,
      required: true
    }
  },
  emits: ['close', 'reload'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const message = ref(null);
    const data = ref(null);
    const file = ref(null);
    const md5Value = ref(null);
    const imageInput = ref(null);
    const buyerId = ref(null);
    const recipientId = ref(null);
    const quantities = ref(1); // computed

    const userType = computed(() => {
      return store.state.user ? parseInt(store.state.user.user_type) : 4;
    });
    const roleArray = computed(() => store.state.role_array ?? null);
    const buyerArray = computed(() => {
      if (!isUserType(userType.value)) return [];
      return roleArray.value.map(item => {
        return {
          'id': item['id'],
          'nickname': item['nickname'],
          'wealth_point': parseFloat(item['wealth_point']).toFixed(1)
        };
      });
    });
    const recipientArray = computed(() => buyerArray.value);
    const buyerWealthPoint = computed(() => {
      if (!buyerId.value) return -Infinity;
      let buffer = buyerArray.value.filter(item => item['id'] === buyerId.value);
      if (buffer.length === 0) return -Infinity;
      return parseFloat(buffer[0]['wealth_point']);
    });
    const totalPrice = computed(() => {
      return (parseFloat((data.value && data.value['price']) ?? '0') * quantities.value).toFixed(1);
    });
    const additionalArray = computed(() => {
      if (!data.value) return [];
      let buffer = [];

      if (data.value?.identified || inApostleType(userType.value)) {
        if (data.value.mysterious_level !== undefined) {
          buffer.push({
            'name': '神秘等级',
            'desc': data.value.mysterious_level
          });
        }

        if (data.value.enchant !== undefined) {
          buffer.push({
            'name': '显露灵能',
            'desc': data.value.enchant ? '是' : '非'
          });
        }

        if (data.value.fortify !== undefined) {
          buffer.push({
            'name': '强化状态',
            'desc': getPropsFortifyDesc(data.value.fortify ?? 0)
          });
        }

        if (data.value.detachable !== undefined) {
          buffer.push({
            'name': '允许拆解',
            'desc': data.value.detachable ? '是' : '非'
          });
        }
      }

      buffer.push({
        'name': '重',
        'desc': data.value.weight ? `${data.value.weight} kg` : '不计'
      });

      if (data.value.binding_type) {
        buffer.push({
          'name': '绑定类型',
          'desc': data.value.binding_type.desc
        });
      } // console.log(JSON.stringify(data.value))


      if (data.value.type.is_stackable || data.value['times'] && data.value['times'] !== 0) {
        buffer.push({
          'name': '可用次数',
          'desc': data.value['times']
        });
      }

      if (data.value.cooldown) {
        buffer.push({
          'name': '冷却',
          'desc': data.value.cooldown.desc
        });
      }

      if (data.value.timing_type) {
        buffer.push({
          'name': '发动时机',
          'desc': data.value.timing_type.desc
        });
      }

      return buffer; // return [...buffer, ...buffer]
    }); // functions

    const getData = () => {
      request('props/market_props/get/', {
        'prop_id': props.propId
      }, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          data.value = response.data;

          if (inApostleType(userType.value) && data.value.type.is_stackable) {
            quantities.value = data.value.times;
          }
        }
      });
    };

    const clickImage = () => {
      if (!inApostleType(userType.value)) return;
      imageInput.value.click();
    };

    const handleInputChange = event => {
      file.value = event.target.files[0];

      if (file.value) {
        compressImage(file.value, 2 * 1024 * 1024, value => {
          file.value = value;
          calculateMD5(file.value, value => {
            // console.log(`md5 = ${value}`)
            md5Value.value = value;
            uploadImage();
          });
        });
      }
    };

    const uploadImage = async () => {
      if (message.value) {
        message.value.close();
      }

      const formData = new FormData();
      formData.append('file', file.value);
      formData.set('name', file.value.name);
      formData.set('path', 'props_images');
      formData.set('md5', md5Value.value);
      formData.set('prop_id', props.propId);
      const headers = {
        'Content-Type': 'multipart/form-data'
      };
      const response = await request('props/market_props/upload_image/', formData, 'UPLOAD', headers); // console.log(`upload_market_props_image ${JSON.stringify(response)}`)

      if (response.code !== 0) {
        message.value = ElMessage.error(response.msg);
        return;
      }

      message.value = ElMessage.success('上传成功');
      data.value.image = response.data;
      file.value = null;
      md5Value.value = null;
      imageInput.value.value = null;
      emits('reload');
    };

    const getPropsFortifyDesc = value => {
      switch (value) {
        case 0:
          return '不可强化';

        case 1:
          return '可强化';

        case 2:
          return '仍可强化';

        case 3:
          return '已强化';

        default:
          return '';
      }
    };

    function submitOrder() {
      if (message.value) {
        message.value.close();
      }

      if (!buyerId.value) {
        message.value = ElMessage.error({
          message: '没有选择出资人',
          duration: 1500
        });
        return;
      }

      if (!recipientId.value) {
        message.value = ElMessage.error({
          message: '没有选择收货人',
          duration: 1500
        });
        return;
      }

      if (buyerWealthPoint.value < totalPrice.value) {
        message.value = ElMessage.error({
          message: `持有余钱无法支付这笔交易`,
          duration: 1500
        });
        return;
      }

      let parameters = {
        'market_prop_id': data.value['id'],
        'quantities': quantities.value,
        'buyer_id': buyerId.value,
        'recipient_id': recipientId.value
      };
      request('transaction/market_transaction/create/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        quantities.value = 1;
        store.dispatch('get_roles');
        store.commit('delete_role_info', {
          role_id: buyerId.value,
          key: 'attribute'
        });
        message.value = ElMessage.success({
          message: '完成购买',
          duration: 1500
        });
        emits('close');
      });
    }

    const submitGift = () => {
      if (message.value) message.value.close();

      if (!recipientId.value) {
        message.value = ElMessage.error({
          message: '没有选择收货人',
          duration: 1500
        });
        return;
      }

      let parameters = {
        'market_prop_id': data.value['id'],
        'quantities': quantities.value,
        'recipient_id': recipientId.value
      };
      request('transaction/create_market_transaction_gift/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        message.value = ElMessage.success({
          message: '完成赠予',
          duration: 1500
        });
        emits('close');
      });
    };

    const updateSelectedRole = (item, isSelected = false) => {
      // console.log('castChanged', item.nickname, isSelected)
      if (isSelected) {
        recipientId.value = item.id;
      } else {
        recipientId.value = null;
      }
    }; // lifecycle


    onMounted(() => {
      getData(); // console.log(JSON.stringify(roleArray.value))

      if (roleArray.value && roleArray.value.length >= 1) {
        if (!buyerId.value) buyerId.value = roleArray.value[0].id;
        if (!recipientId.value) recipientId.value = roleArray.value[0].id;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      return data.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_unref(isAdminType)(userType.value) ? (_openBlock(), _createElementBlock("input", {
        key: 0,
        type: "file",
        accept: "image/png, image/jpeg",
        style: {
          "display": "none"
        },
        ref_key: "imageInput",
        ref: imageInput,
        onChange: handleInputChange
      }, null, 544)) : _createCommentVNode("", true), _createVNode(_component_el_row, {
        class: "props-core-container"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          offset: 2,
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_image, {
            class: "prop-image",
            src: data.value.image && data.value.image.length > 0 ? data.value.image : _unref(propsDefaultImage),
            draggable: "false",
            onClick: clickImage
          }, null, 8, ["src"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          offset: 1,
          span: 13
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_2, [_createTextVNode(_toDisplayString(data.value.name) + " ", 1), _createElementVNode("span", _hoisted_3, _toDisplayString(data.value.type.desc) + " / " + _toDisplayString(data.value.tag.desc), 1), _createElementVNode("span", {
              class: _normalizeClass([`rare-${data.value.rare_level}`, 'rare-tag'])
            }, _toDisplayString(data.value.rare_desc), 3)])]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_4, " 售 " + _toDisplayString(parseFloat(data.value.price).toFixed(1)) + " 资产点 ", 1)]),
            _: 1
          }), _cache[8] || (_cache[8] = _createElementVNode("div", {
            style: {
              "height": "1.0rem"
            }
          }, null, -1)), _unref(isValid)(data.value.cost) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_col, {
            class: "item-row"
          }, {
            default: _withCtx(() => [_cache[4] || (_cache[4] = _createElementVNode("text", {
              class: "item-tag"
            }, "道具消耗", -1)), _createElementVNode("text", _hoisted_6, "    " + _toDisplayString(_unref(parseToCostDesc)(data.value.cost)), 1)]),
            _: 1
          })])) : _createCommentVNode("", true), _createVNode(_component_el_col, {
            class: "item-row"
          }, {
            default: _withCtx(() => [_cache[5] || (_cache[5] = _createElementVNode("text", {
              class: "item-tag"
            }, "形态描述", -1)), _createElementVNode("text", _hoisted_7, "    " + _toDisplayString(data.value['appearance_desc']), 1)]),
            _: 1
          }), _createVNode(_component_el_col, {
            class: "item-row"
          }, {
            default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("text", {
              class: "item-tag"
            }, "性能描述", -1)), _createElementVNode("text", _hoisted_8, "    " + _toDisplayString(data.value['function_desc']), 1)]),
            _: 1
          }), data.value['deep_desc'] ? (_openBlock(), _createBlock(_component_el_col, {
            key: 1,
            class: "item-row"
          }, {
            default: _withCtx(() => [_cache[7] || (_cache[7] = _createElementVNode("text", {
              class: "item-tag"
            }, "深层信息", -1)), _createElementVNode("text", _hoisted_9, "    " + _toDisplayString(data.value['deep_desc']), 1)]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", null, [_createVNode(_component_el_col, {
        offset: 2,
        span: 20
      }, {
        default: _withCtx(() => [_cache[10] || (_cache[10] = _createElementVNode("div", {
          class: "divider"
        }, null, -1)), _createVNode(_component_el_row, {
          class: "prop-additional-container"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionalArray.value, item => {
            return _openBlock(), _createElementBlock("div", {
              class: "prop-additional-item",
              key: item.name
            }, [_createElementVNode("text", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(item.name), 1), _createTextVNode(" " + _toDisplayString(item.desc), 1)])]);
          }), 128))]),
          _: 1
        }), _createVNode(_component_el_row, {
          class: "prop-sales-container"
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createElementVNode("div", {
            class: "prop-sales-item"
          }, [_createElementVNode("text", {
            class: "item-desc"
          }, [_createElementVNode("span", {
            class: "item-name"
          }, "来自"), _createTextVNode(" 海市 ")])], -1)]))]),
          _: 1
        })]),
        _: 1
      })]), _unref(isUserType)(userType.value) ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_el_col, {
        offset: 2,
        span: 20
      }, {
        default: _withCtx(() => [_cache[19] || (_cache[19] = _createElementVNode("div", {
          class: "divider"
        }, null, -1)), _createVNode(_component_el_row, {
          class: "transaction-container"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8,
            class: "transaction-item-container"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("text", null, [_cache[13] || (_cache[13] = _createTextVNode(" 出资人 ", -1)), buyerId.value ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["transaction-desc", buyerWealthPoint.value < totalPrice.value ? 'insufficient' : ''])
            }, [_cache[11] || (_cache[11] = _createTextVNode("  /  持有 ", -1)), _createElementVNode("b", null, _toDisplayString(buyerWealthPoint.value), 1), _cache[12] || (_cache[12] = _createTextVNode(" 资产点 ", -1))], 2)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_select, {
              modelValue: buyerId.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => buyerId.value = $event),
              "show-arrow": false,
              clearable: "",
              placeholder: "选择出资人",
              "popper-class": "propsPopper",
              size: "small"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buyerArray.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.nickname,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])])]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_cache[14] || (_cache[14] = _createElementVNode("div", {
              class: "transaction-title"
            }, " 收货人 ", -1)), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_select, {
              modelValue: recipientId.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => recipientId.value = $event),
              "show-arrow": false,
              clearable: "",
              placeholder: "选择收货人",
              "popper-class": "commonPopper",
              size: "small"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recipientArray.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.nickname,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])])]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createElementVNode("text", null, [_cache[17] || (_cache[17] = _createTextVNode(" 数量 ", -1)), _createElementVNode("span", _hoisted_17, [_cache[15] || (_cache[15] = _createTextVNode("  /  价 ", -1)), _createElementVNode("b", null, _toDisplayString(totalPrice.value), 1), _cache[16] || (_cache[16] = _createTextVNode(" 资产点 ", -1))])])]), _createElementVNode("div", _hoisted_18, [_createVNode(_unref(ElInputNumber), {
              modelValue: quantities.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => quantities.value = $event),
              max: 10,
              min: 1
            }, null, 8, ["modelValue"])])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          style: {
            "justify-content": "flex-end",
            "margin-top": "2.0rem"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "submit-order",
            onClick: submitOrder
          }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode(" 提交购买 ", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })])) : _createCommentVNode("", true), _unref(isAdminType)(userType.value) ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_el_col, {
        offset: 2,
        span: 20
      }, {
        default: _withCtx(() => [_cache[21] || (_cache[21] = _createElementVNode("div", {
          class: "divider"
        }, null, -1)), _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_row, {
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(RoleFinder, {
            "close-on-click": true,
            onSelectedRole: updateSelectedRole
          })]),
          _: 1
        }), _createVNode(_unref(ElInputNumber), {
          modelValue: quantities.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => quantities.value = $event),
          max: 10,
          min: 1
        }, null, 8, ["modelValue"])]), _createVNode(_component_el_row, {
          style: {
            "justify-content": "flex-end",
            "margin-top": "2.0rem"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "submit-order",
            onClick: submitGift
          }, {
            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode(" 提交赠予 ", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
    };
  }

};